export default "__VITE_PUBLIC_ASSET__a6dcb703__"